import React, { useEffect, useState, useContext } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'

import UserContext from '../../../context/UserContext'
import * as moment from "moment-timezone"
import { deepClone } from '../../../utils/clone'

const HealthStatusServicePositionator = ({ data, env }) => {

    const token = useContext(UserContext)
    const tab_col = [
        {
            field: "id",
            headerName: "Account ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const tab_col2 = [
        {
            field: "id",
            headerName: "Connection Id",
            minWidth: 280,
            suppressSizeToFit: true,
        },
        {
            field: "connect_time",
            headerName: "Connection Time",
            minWidth: 180,
            suppressSizeToFit: true,
        },
        {
            field: "is_subscribed",
            headerName: "Subscribed",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "conflation_ms",
            headerName: "Conflation",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "user_id",
            headerName: "User Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "client_ip",
            headerName: "Client IP",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        if (data.accounts) {
            tab_data_temp = Object.keys(data.accounts).reduce((rowData, rowId) => {

                const row = deepClone(data.accounts[rowId])
                rowData.push({
                    uniqueId: row.id,
                    id: row.id,
                    status: row.status || '-'
                })
                return rowData
            }, [])
        }

        settab_data(tab_data_temp)
    }, [data.accounts])

    const [tab_data2, settab_data2] = useState([])

    useEffect(() => {
        let tab_data2_temp = []
        if (data.connections) {
            tab_data2_temp = Object.keys(data.connections).reduce((rowData, rowId) => {
                const row = deepClone(data.connections[rowId])

                let timestamp_temp = ''
                timestamp_temp = moment(moment(row.connect_time).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                timestamp_temp = moment(timestamp_temp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

                rowData.push({
                    uniqueId: row.id,
                    id: row.id,
                    connect_time: timestamp_temp,
                    client_ip: row.client_ip || '-',
                    is_subscribed: row.is_subscribed || '-',
                    user_id: row.user_id || '-',
                    conflation_ms: row.conflation_ms | '-'
                })
                return rowData
            }, [])
        }
        settab_data2(tab_data2_temp)
    }, [data.connections, token.timezone])


    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            {tab_data.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Accounts</Text>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="HealthStatusServicePositionatorAccts"
                        tableHeight={700}
                    />
                </>
            }

            {tab_data2.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }}
                        size="small" color="dark-3" weight="bold">Connections</Text>
                    <AgDataTable
                        tab_col={tab_col2}
                        tab_data={tab_data2}
                        tableName="HealthStatusServicePositionatorConnections"
                        tableHeight={700}
                    />
                </>
            }
        </Box>
    )
}

export default HealthStatusServicePositionator